<div class="titulo-div " [style.background]="backgroudColor">
  <div>
    <div class="d-flex flex-row align-items-center">
      <ng-container *ngIf="isDesktop">
        <h2 class="quicksand-bold title ">ACREDITACIÓN: <span style=" margin-left: 2px;"
            class="quicksand-medium title ">{{accreditation}}</span></h2>
      </ng-container>
      <ng-container *ngIf="!isDesktop">
        <h2 style="margin-left: 0px;" class="quicksand-medium title ">ACREDITACIÓN: <span style=" margin-left: 2px;"
            class="quicksand-medium title ">{{accreditation}}</span></h2>
      </ng-container>
    </div>

  </div>



</div>


<div class="planEstudio-div">
  <div class="izq">
    <ng-container *ngFor="let item of planData; let i = index">
      <div (click)="onSelectItem(i)" [ngClass]="{ 'item-activo': selectedItemIndex === i }" class="item-estudio"
        [style.background-color]="selectedItemIndex === i ? backgroudColor : null">
        <span class="mas quicksand-bold">+</span>
        <span class="quicksand-bold item-titulo">{{ item.title }}</span>
      </div>

    </ng-container>
    <!--<div class="mb-3">
      <button class="btn-entrevista nunito-medium" (click)="openModal()">RECIBÍ MÁS INFORMACIÓN</button>
    </div>-->
  </div>

  <div class="derecha">
    <!-- <h2 class="tituloBody nunito-bold">{{titlehtml | uppercase}}</h2> -->
    <div class="content-wrapper" [class.expanded]="expanded" #contentWrapper>
      <div [innerHTML]="htmlsanitizado" class="nunito-medium bodyplan"></div>
    </div>
    <hr>
    <div class="expand-container" *ngIf="showExpandButton && planData.length > 0">
      <button (click)="toggleExpand()" class="expand-button">
        {{ expanded ? 'ver -' : 'ver +' }}
      </button>
    </div>

  </div>
</div>